// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-wide toast look (import after react-toastify/dist/ReactToastify.css) */

.Toastify__toast-container {
  width: min(420px, 92vw) !important;
  padding: 10px !important;
}

.Toastify__toast {
  border-radius: 12px !important;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14), 0 2px 8px rgba(15, 23, 42, 0.08) !important;
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  min-height: 56px !important;
  padding: 14px 16px !important;
}

.Toastify__toast--error {
  background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%) !important;
  color: #9f1239 !important;
  border: 1px solid #fecdd3 !important;
  border-left: 5px solid #e11d48 !important;
}

.Toastify__toast--error .Toastify__toast-icon svg {
  fill: #e11d48 !important;
}

.Toastify__toast--error .Toastify__progress-bar {
  background: linear-gradient(90deg, #fb7185, #e11d48) !important;
}

.Toastify__toast--success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%) !important;
  color: #065f46 !important;
  border: 1px solid #a7f3d0 !important;
  border-left: 5px solid #059669 !important;
}

.Toastify__toast--success .Toastify__toast-icon svg {
  fill: #059669 !important;
}

.Toastify__toast--success .Toastify__progress-bar {
  background: linear-gradient(90deg, #34d399, #059669) !important;
}

.Toastify__toast--warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;
  color: #92400e !important;
  border: 1px solid #fde68a !important;
  border-left: 5px solid #f59e0b !important;
}

.Toastify__toast--warning .Toastify__toast-icon svg {
  fill: #d97706 !important;
}

.Toastify__toast--info {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
  color: #1e3a8a !important;
  border: 1px solid #bfdbfe !important;
  border-left: 5px solid #2563eb !important;
}

.Toastify__toast--info .Toastify__toast-icon svg {
  fill: #2563eb !important;
}

.Toastify__close-button {
  opacity: 0.55 !important;
  color: inherit !important;
}

.Toastify__close-button:hover {
  opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/app-toast.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,2FAA2F;EAC3F,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* App-wide toast look (import after react-toastify/dist/ReactToastify.css) */\n\n.Toastify__toast-container {\n  width: min(420px, 92vw) !important;\n  padding: 10px !important;\n}\n\n.Toastify__toast {\n  border-radius: 12px !important;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14), 0 2px 8px rgba(15, 23, 42, 0.08) !important;\n  font-family: inherit !important;\n  font-size: 14px !important;\n  line-height: 1.45 !important;\n  min-height: 56px !important;\n  padding: 14px 16px !important;\n}\n\n.Toastify__toast--error {\n  background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%) !important;\n  color: #9f1239 !important;\n  border: 1px solid #fecdd3 !important;\n  border-left: 5px solid #e11d48 !important;\n}\n\n.Toastify__toast--error .Toastify__toast-icon svg {\n  fill: #e11d48 !important;\n}\n\n.Toastify__toast--error .Toastify__progress-bar {\n  background: linear-gradient(90deg, #fb7185, #e11d48) !important;\n}\n\n.Toastify__toast--success {\n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%) !important;\n  color: #065f46 !important;\n  border: 1px solid #a7f3d0 !important;\n  border-left: 5px solid #059669 !important;\n}\n\n.Toastify__toast--success .Toastify__toast-icon svg {\n  fill: #059669 !important;\n}\n\n.Toastify__toast--success .Toastify__progress-bar {\n  background: linear-gradient(90deg, #34d399, #059669) !important;\n}\n\n.Toastify__toast--warning {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;\n  color: #92400e !important;\n  border: 1px solid #fde68a !important;\n  border-left: 5px solid #f59e0b !important;\n}\n\n.Toastify__toast--warning .Toastify__toast-icon svg {\n  fill: #d97706 !important;\n}\n\n.Toastify__toast--info {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;\n  color: #1e3a8a !important;\n  border: 1px solid #bfdbfe !important;\n  border-left: 5px solid #2563eb !important;\n}\n\n.Toastify__toast--info .Toastify__toast-icon svg {\n  fill: #2563eb !important;\n}\n\n.Toastify__close-button {\n  opacity: 0.55 !important;\n  color: inherit !important;\n}\n\n.Toastify__close-button:hover {\n  opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
